import NextArrow from "../../carousel/nextArrow";
import PrevArrow from "../../carousel/prevArrow";
import Slider from "react-slick";
import "./topBrands.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const topBrandsList = [
  {
    id: 1,
    time: "29 min",
    cover:
      "https://b.zmtcdn.com/data/brand_creatives/logos/775f928725d1a9dd80422632de22c224_1611377090.png?output-format=webp",
  },
  {
    id: 2,
    time: "25 min",
    cover:
      "https://b.zmtcdn.com/data/brand_creatives/logos/1a985408ca7ad8fd097f2c47db9c5cb6_1611252811.png?output-format=webp",
  },
  {
    id: 3,
    time: "34 min",
    cover:
      "https://b.zmtcdn.com/data/brand_creatives/logos/c38f7540bcc5a38e918856ac06409056_1504531339.png?output-format=webp",
  },
  {
    id: 4,
    time: "45 min",
    cover:
      "https://b.zmtcdn.com/data/brand_creatives/logos/6a11fd0f30c9fd9ceaff2f5b21f61d23_1617188299.png?output-format=webp",
  },
  {
    id: 5,
    time: "45 min",
    cover:
      "https://b.zmtcdn.com/data/brand_creatives/logos/9da52e2b69f19bb603227a750e788d33_1613215152.png?output-format=webp",
  },
  {
    id: 6,
    time: "18 min",
    cover:
      "https://b.zmtcdn.com/data/brand_creatives/logos/45137b90df2f1154a8766b00c03c8fc3_1655798578.png?output-format=webp",
  },
  {
    id: 7,
    time: "33 min",
    cover:
      "https://b.zmtcdn.com/data/brand_creatives/logos/5a27a3f43344ecdb49c575d0284ebc40_1629438578.png?output-format=webp",
  },
  {
    id: 8,
    time: "28 min",
    cover:
      "https://b.zmtcdn.com/data/brand_creatives/logos/0586860837a45545296c0c4306d260f2_1491906156.png?output-format=webp",
  },
  {
    id: 9,
    time: "31 min",
    cover:
      "https://b.zmtcdn.com/data/brand_creatives/logos/9302c59eca94abbee01aec9acf9305f6_1676471832.png?output-format=webp",
  },
  {
    id: 10,
    time: "30 min",
    cover:
      "https://b.zmtcdn.com/data/brand_creatives/logos/dc25345966698c3077d648ecf3c5b3d1_1643349142.png?output-format=webp",
  },
];

const settings = {
  infinite: false,
  slidesToShow: 6,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

const TopBrands = () => {
  return (
    <div className="bg-gray-100 py-8">
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="text-3xl font-semibold mb-4">
          Top brands for you
        </div>
        <Slider {...settings} className="slider">
          {topBrandsList.map((brand) => (
            <div key={brand.id} className="px-2">
              <div className="top-brands-cover">
                <img
                  src={brand.cover}
                  className="top-brands-image"
                  alt={brand.time}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TopBrands;
